import { inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { State } from '../reducers';
import * as ShopCartSelectors from '../reducers/shop-cart.reducer';
import { I18nService } from '../services';

@Injectable({
  providedIn: 'root'
})
export class PreventAccessWithEmptyCartGuard implements CanActivate {
  private readonly router: Router = inject(Router);
  private readonly store: Store<State> = inject(Store);
  private readonly i18nService: I18nService = inject(I18nService);

  loadingCartDataInProgress$: Observable<boolean> = this.store.select(ShopCartSelectors.selectLoadingCartDataInProgress);
  cartItems$: Observable<any> = this.store.select(ShopCartSelectors.selectCartItems);

  canActivate(): Observable<boolean> {
    return combineLatest([
      this.loadingCartDataInProgress$,
      this.cartItems$
    ]).pipe(
      filter(([loadingCartDataInProgress, cartItems]: [boolean, any]) => !loadingCartDataInProgress && cartItems),
      map(([_loadingCartDataInProgress, cartItems]: [boolean, any]) => {
        if (cartItems.data.attributes.totalItemsQuantity === 0) {
          this.router.navigate([this.i18nService.getCurrentLocale()]);
          return false;
        }
        return true;
      })
    );
  }
}
